import { makeStyles } from '@material-ui/core/styles';
export default makeStyles((theme) => ({
  dialogPaper: {
    height: '80vh',
  },
  subtitle: {
    fontWeight: 'bold',
  },
}));
